module.exports = __webpack_public_path__ + "assets/img/Ic-LiveChat.5c61e739.png";